const values = [0, 8, 16, 24, 32, 40, 48, 56, 64, 72, 80];
const space = Object.assign(values, {
    gutterMobile: values[2],
    gutterTablet: values[2],
    gutterDesktop: values[3],
});
export { space };
